import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	inject,
	input,
	Input,
	//LOCALE_ID,
	Output,
} from '@angular/core';
import {
	IAuComment,
	IAuCommentEditEvent,
} from '@shared/ui-components/au-comments/i-au.comment';
import { CommentItemComponent } from './comment-item/comment-item.component';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DateSortingPipe } from '@app/shared/pipes/sort-date.pipe';
import { IRequester } from '@app/pages/cmms/interfaces/request.interfaces';
import { AuPipesModule } from '@app/shared/pipes/au-pipes.module';
import { DateAgoPipe } from '@app/shared/pipes/date-ago.pipe';
import { MatButtonModule } from '@angular/material/button';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'au-comments',
	templateUrl: './au-comments.component.html',
	styleUrls: ['./au-comments.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,

	imports: [
		CommentItemComponent,
		CommonModule,
		MatSlideToggleModule,
		DateSortingPipe,
		AuPipesModule,
		MatButtonModule,
		NgxTolgeeModule,
	],
	providers: [DateAgoPipe],
})
export class AuCommentsComponent {
	@Input() commentsList: IAuComment[] = [];
	@Input() requester: IRequester[];

	@Output() editComment = new EventEmitter<IAuCommentEditEvent>();
	@Output() deleteComment = new EventEmitter<{ commentId: string }>();

	isRequest = input(false);
	private readonly dateAgoPipe = inject(DateAgoPipe);
	private lastDate: string | null = null;

	shouldShowSeparator(commentDate: Date): boolean {
		const formattedDate = this.dateAgoPipe.transform(commentDate, false);
		if (this.lastDate !== formattedDate) {
			this.lastDate = formattedDate;
			return true;
		}
		return false;
	}

	resetLastDate() {
		this.lastDate = null;
	}
}
